<template lang="html">
  <div class="cw-service-data-cell">
    <cw-accordion
      :height="expandedHeight"
      :showOpenIndicator="false"
      :open="editing"
      @update:open="val => this.$emit('update:editing', val)"
      :overflowType="overflowType"
    >
      <div slot="header">
        <cw-basic-cell>
          <div slot="left-area">
            <h2
              class="step-number has-text-weight-semibold is-size-4"
              @click="toggleExpand()"
            >
              {{ stepNumber || '' }}
            </h2>
          </div>
          <div slot="left-fill-area">
            <p class="is-size5 has-text-grey-light">{{ description }}</p>
            <p class="is-size5 is-size6-mobile" v-show="!editing">
              {{ inputDisplayValue }}
            </p>
          </div>
        </cw-basic-cell>
      </div>
      <div slot="content" class="input-container" :class="{ padded: padInput }">
        <div class="input-control" v-on:keyup.enter="toggleExpand()">
          <slot name="input-control"></slot>
        </div>
      </div>
    </cw-accordion>
  </div>
</template>

<script>
export default {
  name: 'cw-service-data-cell',
  components: {},
  props: {
    description: {
      type: String,
      required: true,
    },
    inputValue: {
      type: String,
      required: false,
      default: '',
    },
    displayValue: {
      type: String,
      required: false,
      default: '',
    },
    stepNumber: {
      type: Number,
      required: false,
    },
    extraToggleActions: {
      type: Function,
      required: false,
      default: () => {},
    },
    editing: {
      type: Boolean,
      required: false,
      default: false,
    },
    expandedHeight: {
      type: String,
      required: false,
      default: '60px',
    },
    overflowType: {
      type: String,
      required: false,
      default: 'visible',
    },
    padInput: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    inputDisplayValue() {
      return (
        (this.displayValue &&
          this.displayValue.length > 0 &&
          this.displayValue) ||
        this.inputValue
      );
    },
  },
  methods: {
    toggleExpand() {
      this.$emit('update:editing', !this.editing);
    },
  },
};
</script>

<style lang="stylus" scoped>

$itemPadding = 0.5rem
.cw-service-data-cell {
  user-select: none
  border-bottom: 1px solid #ddd

    &.danger {
      background: rgba(255,0,0, 0.1);
    }
}
.step-number {
  color: red;
  width: 1.5rem;
  text-align: center;
}
.input-container.padded {
  // The step number width + the padding of the cell left-area + padding cell left-fill-area
  margin-left: 2.5rem;
  margin-right: 2rem;
}
</style>
